export function replaceMobileCartButton () {
    let mobileCartButton = document.querySelector('.headerAccount__mobile .iconbarItem.iconbarItem--basket');
    let mobileSlideNavigation = document.querySelector('.headerAccount__mobile .iconbar');

    if (mobileCartButton && mobileSlideNavigation) {
        mobileSlideNavigation.append(mobileCartButton);
    }
}